import React from "react"
import { QuantityInput } from "./QuantityInput"
import { isTomorrow } from "../../services/Utils"

export class AddToCartV2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = { quantity: props.product_unit.quantity_minimum }

    this.addToCartBackorder = this.addToCartBackorder.bind(this)
    this.addToCart = this.addToCart.bind(this)
  }

  renderQuantityInput() {
    if (!this.props.showPricing || !this.props.cartEnabled) { return }
    const product_unit = this.props.product_unit
    return (
      <div className="align-self-center pr-1">
        <QuantityInput
          id={ product_unit.unit }
          minimum={ product_unit.quantity_minimum }
          maximum={ product_unit.quantity_maximum }
          value={this.state.quantity}
          onChange={this.onChangeQuantity.bind(this)}
        />
      </div>
    )
  }

  onChangeQuantity(newValue) {
    this.setState({ quantity: newValue })
  }

  addToCart() {
    const buyer_order_item_params = {
      product_unit_id: this.props.product_unit.product_unit_id,
      quantity: this.state.quantity
    }
    this.props.addItem(buyer_order_item_params, this.props.product_unit.name, this.props.src)
  }

  addToCartBackorder(unavailable_type) {
    const buyer_order_item_params = {
      backorder: true,
      unavailable_type: unavailable_type,
      product_unit_id: this.props.product_unit.product_unit_id,
      quantity: this.state.quantity
    }
    this.props.addItem(buyer_order_item_params, this.props.product_unit.name, this.props.src)
  }

  renderAddToCart(unavailable_type) {
    if (!this.props.cartEnabled || !this.props.showPricing) {
      return (
        <div>
          <a
            className="btn btn-sm btn-outline-secondary text-nowrap"
            href={"/admin/seller/" + this.props.seller_id + "/browse"}
          >
            Sign In to Purchase
          </a>
        </div>
      )
    }
    const colorClass = this.props.colorClass || `btn-${ this.colorClass(unavailable_type) }`
    var text = 'Add'
    if ( unavailable_type == 'temporary' ) { text = 'Backorder' }
    if ( unavailable_type == 'preorder' ) { text = 'Preorder' }
    if ( unavailable_type == 'special' ) { text = 'Request' }

    var addToCartFunction = unavailable_type ? this.addToCartBackorder : this.addToCart
    return (
      <div className='w-100'>
        <button type="button"
                className={ `py-0 px-1 btn ${ colorClass } btn-block` }
                onClick={ () => { addToCartFunction(unavailable_type) } }>
          <div>{ text }</div>
          <div className='small text-nowrap sku'>Item# { this.props.product_unit.sku}</div>
        </button>
      </div>
    )
  }

  colorClass(type) {
    switch (type) {
      case 'temporary':
        return 'warning'
      case 'indefinite':
        return 'danger'
      case 'preorder':
        return 'success'
      case 'special':
        return 'warning'
      default:
        return 'success'
    }
  }

  renderAvailabilityMessage() {
    const product_unit = this.props.product_unit
    const indefinite = product_unit.unavailable_type == 'indefinite'
    if (product_unit.earliestDeliveryOn && !indefinite) { return }
    if (!product_unit.unavailable_until_description) { return }

    const colorClass = this.colorClass(this.props.product_unit.unavailable_type)

    return (
      <div className='mb-2'>
        <div className={ `badge badge-pill border border-${ colorClass } text-wrap` }>
          <span className='fa fa-exclamation-triangle mr-2'></span>
          { product_unit.unavailable_until_description }
        </div>
      </div>
    )
  }

  renderSpecialOrderItem() {
    return (
      <div className='mb-2'>
        <span className='badge border badge-pill'>Out of Stock</span>
      </div>
    )
  }

  renderAvailabilityDate() {
    if (!this.props.showAvailability) { return }
    if (this.props.product_unit.unavailable_type == 'indefinite') { return }

    const earliestDeliveryOn = this.props.product_unit.earliestDeliveryOn
    if (!earliestDeliveryOn) { return this.renderSpecialOrderItem() }

    const date = new Date(`${ earliestDeliveryOn }T00:00:00`);
    let formattedDeliveryOn = date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric"
    });
    if (isTomorrow(earliestDeliveryOn))
      formattedDeliveryOn = 'Tomorrow';

    const colorClass = this.colorClass()
    return (
      <div className='mb-2' >
        <span className={ `small border-${ colorClass } text-wrap` } data-controller='tooltip' title='Earliest Delivery'>
          <span className='fa fa-truck mr-1'></span>{ formattedDeliveryOn }
        </span>
      </div>
    )
  }

  renderQtyAndButton(unavailable_type) {
    if (unavailable_type == 'indefinite') { return }
    return (
      <div className='d-flex'>
        { this.renderQuantityInput() }
        { this.renderAddToCart(unavailable_type) }
      </div>
    )
  }

  render() {
    const product_unit = this.props.product_unit

    if (!this.props.requestedOn) {
      return (
        <div className="badge border text-wrap">
          Choose a delivery date to add to cart
        </div>
      )
    }

    let type = product_unit.unavailable_type

    if (type == 'preorder' && this.props.requestedOn > product_unit.first_available_on) {
      type = ''
    }

    if (!type) {
      if (!product_unit.earliestDeliveryOn) {
        type = 'temporary'
      } else if (this.props.requestedOn && this.props.requestedOn < product_unit.earliestDeliveryOn) {
        type = 'temporary'
      }
    }

    return (
      <div className="product-unit">
        { this.renderAvailabilityMessage() }
        { this.renderAvailabilityDate() }
        { this.renderQtyAndButton(type) }
      </div>
    )
  }
}
